import DOMPurify from 'dompurify';

/**
 * Ce que produisent l'éditeur Tiptap du site (StarterKit, liens, alignement,
 * styles de texte, surlignage, variables) et l'export Draft.js du proposal.
 * Rien d'autre n'a à atteindre `dangerouslySetInnerHTML` : le HTML stocké passe
 * par l'API, qui accepte n'importe quel contenu, et le site partage l'origine
 * de l'éditeur (JWT dans le localStorage).
 *
 * Garder synchronisé avec `Proposals::WebHtmlSanitizer` côté Rails.
 */
export const RICH_HTML_TAGS = [
  'p', 'br', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'strong', 'b', 'em', 'i', 'u', 's', 'del', 'strike', 'sub', 'sup', 'mark', 'span', 'a',
  'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'hr', 'div',
];

export const RICH_HTML_ATTRIBUTES = ['href', 'target', 'rel', 'download', 'style', 'class', 'id', 'start', 'type'];

const CONFIG = {
  ALLOWED_TAGS: RICH_HTML_TAGS,
  ALLOWED_ATTR: RICH_HTML_ATTRIBUTES,
  // `data-*` : variables (`data-variable*`, `data-type`), liens de la banque
  // (`data-link-id`), surlignage (`data-color`).
  ALLOW_DATA_ATTR: true,
};

/** HTML riche nettoyé, prêt pour `dangerouslySetInnerHTML`. */
export function sanitizeRichHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), CONFIG);
}
